export const pluralize = (count, word) => 
    `${count} ${word}${count !== 1 ? 's' : ''}`;